// extracted by mini-css-extract-plugin
export default {"item":"dropdown-item_item__gE8ld","placeHolderShimmer":"dropdown-item_placeHolderShimmer__lVWfC"};